export function clampNumber(value: number, min: number, max: number) {
  return Math.min(max, Math.max(min, value));
}

export function toCentsFromNumber(value: number) {
  if (!Number.isFinite(value)) return 0;
  return Math.round(value * 100);
}

export function toCentsFromString(value: string) {
  const raw = (value ?? "").toString().trim();
  if (!raw) return 0;

  // Aceita formatos pt-BR e en-US:
  // - "20" -> 20
  // - "20," / "20,5" / "20,50"
  // - "1.234,56" (pt-BR)
  // - "1234.56" (en-US)
  // Remove símbolos e espaços, preservando dígitos e separadores.
  let cleaned = raw.replace(/[^0-9,.-]/g, "");

  // Se tiver vírgula, assumimos pt-BR: "." como milhar e "," como decimal.
  if (cleaned.includes(",")) {
    cleaned = cleaned.replace(/\./g, "").replace(/,/g, ".");
  }

  const n = Number.parseFloat(cleaned);
  return toCentsFromNumber(Number.isFinite(n) ? n : 0);
}

export function centsToFixedString(cents: number) {
  const safe = Number.isFinite(cents) ? cents : 0;
  return (safe / 100).toFixed(2);
}

export function formatBRLCurrencyFromCents(cents: number) {
  const safe = Number.isFinite(cents) ? cents : 0;
  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(safe / 100);
}
